





























import { Store } from '@/model/Store';
import { StoreService } from '@/services/StoreService';
import { Inject } from 'vue-typedi';
import {Watch, Component, Vue} from 'vue-property-decorator';
import StorePanel from '@/components/stores/StorePanel.vue';
import StoreParams from '@/components/stores/StoreParams.vue';

@Component({
    components: {StorePanel, StoreParams}
})
export default class StoresBody extends Vue {

    @Inject()
    storeService!: StoreService;

    private allStores: Store[] = [];
    private filteredStores: Store[] = [];
    private selectedStore: Store = null;

    public searchTerms: string = "";

    created() {
        this.getAllStores();
    }

    private getAllStores() {
        this.storeService.getStores().then(data => {
            this.allStores = this.getSortedStores(data.stores);
            this.filteredStores = this.getSortedStores(data.stores);
        })
    }

    private getSortedStores(stores: Store[]): Store[] {
        if (stores === null) {
            return [];
        }

        return stores.sort((a, b) => a.storeId > b.storeId ? 1 : -1);
    }

    @Watch('searchTerms')
    private onSearchTermsChanged() {
        this.filterStores();
    }

    private filterStores() {
        if (this.searchTerms === null || this.searchTerms === "") {
            this.filteredStores = this.allStores;
            return;
        }

        this.filteredStores = this.allStores
            .filter(store => store.storeId.includes(this.searchTerms) 
                || store.storeLabel.toLowerCase().includes(this.searchTerms.toLowerCase())
            );
    }

    private onClickStoreParams(storeId: string) {
        this.selectedStore = this.filteredStores.find(store => store.storeId === storeId);
    }

    private onReturnStoresPage() {
        this.selectedStore = null;
    }

}

